import { AudienceAidesHub } from '../../../components/aides/AudienceAidesHub';
import { AIDES_TERTIAIRE } from '../../../config/aides-tertiaire';

export default function TertiaireAidesHubPage() {
  return (
    <AudienceAidesHub
      audienceId="tertiaire"
      aides={AIDES_TERTIAIRE}
      heroEyebrow="Panorama 2026 · 5 leviers cumulables"
      heroHeadline="Vos leviers de financement pour"
      heroHeadlineAccent="vos immeubles tertiaires."
      heroIntro="Primes CEE pour le bâtiment tertiaire (pompes à chaleur, GTB, isolation, relamping), Coup de pouce chauffage-climatisation, suramortissement fiscal et prêts Bpifrance climat : quatre leviers cumulables pour financer votre plan de réduction des consommations dans le cadre du Décret Tertiaire (objectif −40 % à 2030) sur un patrimoine d'au moins 1 000 m²."
      primaryCta={{ label: "Lancer l'audit Décret Tertiaire", href: '/tertiaire/decret-tertiaire' }}
      secondaryCta={{ label: 'Estimer mes primes CEE tertiaires', href: '/tertiaire/diagnostic-cee' }}
      bullets={['Sources réglementaires citées', 'Sans inscription · sans engagement', 'Accord de confidentialité dès le 1er échange']}
      gridEyebrow="5 leviers de financement et d'économies"
      gridTitle="Les aides mobilisables sur votre patrimoine tertiaire"
      ctaFinalTitle="Sécurisez votre conformité tertiaire 2030"
      ctaFinalDescription="Audit Décret Tertiaire chiffré, plan d'actions financé par des primes CEE bâtiment tertiaire, accompagnement en cas de contrôle par l'ADEME (agence de la transition écologique). Référent dédié · Accord de confidentialité disponible."
    />
  );
}
